/* Copyright (c) 2010 Brandon Aaron (http://brandonaaron.net)
 * Dual licensed under the MIT (MIT_LICENSE.txt)
 * and GPL Version 2 (GPL_LICENSE.txt) licenses.
 *
 * Version: 1.1.1
 * Requires jQuery 1.3+
 * Docs: http://docs.jquery.com/Plugins/livequery
 */
(function(a){a.extend(a.fn,{livequery:function(e,d,c){var b=this,f;if(a.isFunction(e)){c=d,d=e,e=undefined}a.each(a.livequery.queries,function(g,h){if(b.selector==h.selector&&b.context==h.context&&e==h.type&&(!d||d.$lqguid==h.fn.$lqguid)&&(!c||c.$lqguid==h.fn2.$lqguid)){return(f=h)&&false}});f=f||new a.livequery(this.selector,this.context,e,d,c);f.stopped=false;f.run();return this},expire:function(e,d,c){var b=this;if(a.isFunction(e)){c=d,d=e,e=undefined}a.each(a.livequery.queries,function(f,g){if(b.selector==g.selector&&b.context==g.context&&(!e||e==g.type)&&(!d||d.$lqguid==g.fn.$lqguid)&&(!c||c.$lqguid==g.fn2.$lqguid)&&!this.stopped){a.livequery.stop(g.id)}});return this}});a.livequery=function(b,d,f,e,c){this.selector=b;this.context=d;this.type=f;this.fn=e;this.fn2=c;this.elements=[];this.stopped=false;this.id=a.livequery.queries.push(this)-1;e.$lqguid=e.$lqguid||a.livequery.guid++;if(c){c.$lqguid=c.$lqguid||a.livequery.guid++}return this};a.livequery.prototype={stop:function(){var b=this;if(this.type){this.elements.unbind(this.type,this.fn)}else{if(this.fn2){this.elements.each(function(c,d){b.fn2.apply(d)})}}this.elements=[];this.stopped=true},run:function(){if(this.stopped){return}var d=this;var e=this.elements,c=a(this.selector,this.context),b=c.not(e);this.elements=c;if(this.type){b.bind(this.type,this.fn);if(e.length>0){a.each(e,function(f,g){if(a.inArray(g,c)<0){a.event.remove(g,d.type,d.fn)}})}}else{b.each(function(){d.fn.apply(this)});if(this.fn2&&e.length>0){a.each(e,function(f,g){if(a.inArray(g,c)<0){d.fn2.apply(g)}})}}}};a.extend(a.livequery,{guid:0,queries:[],queue:[],running:false,timeout:null,checkQueue:function(){if(a.livequery.running&&a.livequery.queue.length){var b=a.livequery.queue.length;while(b--){a.livequery.queries[a.livequery.queue.shift()].run()}}},pause:function(){a.livequery.running=false},play:function(){a.livequery.running=true;a.livequery.run()},registerPlugin:function(){a.each(arguments,function(c,d){if(!a.fn[d]){return}var b=a.fn[d];a.fn[d]=function(){var e=b.apply(this,arguments);a.livequery.run();return e}})},run:function(b){if(b!=undefined){if(a.inArray(b,a.livequery.queue)<0){a.livequery.queue.push(b)}}else{a.each(a.livequery.queries,function(c){if(a.inArray(c,a.livequery.queue)<0){a.livequery.queue.push(c)}})}if(a.livequery.timeout){clearTimeout(a.livequery.timeout)}a.livequery.timeout=setTimeout(a.livequery.checkQueue,20)},stop:function(b){if(b!=undefined){a.livequery.queries[b].stop()}else{a.each(a.livequery.queries,function(c){a.livequery.queries[c].stop()})}}});a.livequery.registerPlugin("append","prepend","after","before","wrap","attr","removeAttr","addClass","removeClass","toggleClass","empty","remove","html");a(function(){a.livequery.play()})})(jQuery);

(function ($) {
    var selectors = [];
  
    var checkBinded = false;
    var checkLock = false;
    var defaults = {
      interval: 250,
      force_process: false
    };
    var $window = $(window);
  
    var $priorAppeared = [];
  
    function isAppeared() {
      return $(this).is(':appeared');
    }
  
    function isNotTriggered() {
      return !$(this).data('_appear_triggered');
    }
  
    function process() {
      checkLock = false;
  
      for (var index = 0, selectorsLength = selectors.length; index < selectorsLength; index++) {
        var $appeared = $(selectors[index]).filter(isAppeared);
  
        $appeared
          .filter(isNotTriggered)
          .data('_appear_triggered', true)
          .trigger('appear', [$appeared]);
  
        if ($priorAppeared[index]) {
          var $disappeared = $priorAppeared[index].not($appeared);
          $disappeared
            .data('_appear_triggered', false)
            .trigger('disappear', [$disappeared]);
        }
        $priorAppeared[index] = $appeared;
      }
    }
  
    function addSelector(selector) {
      selectors.push(selector);
      $priorAppeared.push();
    }
  
    // ":appeared" custom filter
    $.expr.pseudos.appeared = $.expr.createPseudo(function (_arg) {
      return function (element) {
        var $element = $(element);
  
        if (!$element.is(':visible')) {
          return false;
        }
  
        var windowLeft = $window.scrollLeft();
        var windowTop = $window.scrollTop();
        var offset = $element.offset();
        var left = offset.left;
        var top = offset.top;
  
        if (top + $element.height() >= windowTop &&
            top - ($element.data('appear-top-offset') || 0) <= windowTop + $window.height() &&
            left + $element.width() >= windowLeft &&
            left - ($element.data('appear-left-offset') || 0) <= windowLeft + $window.width()) {
          return true;
        }
        return false;
      };
    });
  
    $.fn.extend({
      // watching for element's appearance in browser viewport
      appear: function (selector, options) {
        $.appear(this, options);
        return this;
      }
    });
  
    $.extend({
      appear: function (selector, options) {
        var opts = $.extend({}, defaults, options || {});
  
        if (!checkBinded) {
          var onCheck = function () {
            if (checkLock) {
              return;
            }
            checkLock = true;
  
            setTimeout(process, opts.interval);
          };
  
          $(window).scroll(onCheck).resize(onCheck);
          checkBinded = true;
        }
  
        if (opts.force_process) {
          setTimeout(process, opts.interval);
        }
  
        addSelector(selector);
      },
      // force elements's appearance check
      force_appear: function () {
        if (checkBinded) {
          process();
          return true;
        }
        return false;
      }
    });
  }(function () {
    if (typeof module !== 'undefined') {
      // Node
      return require('jquery');
    }
    return jQuery;
  }()));


$(document).ready(function () {  

    jQuery(".box-images img").each(function () {
        var imgAlt = jQuery(this).attr('alt').toLowerCase();
        jQuery(this).attr("data-name-model", imgAlt.split("/")[0]);
        // jQuery(this).attr("data-variant-color", imgAlt.split("/")[1]);
        jQuery(this).attr("data-variant-color", imgAlt.split("/")[1]);
        if(imgAlt == "all") {
            jQuery(this).parents(".thumb-item").attr("alt", imgAlt);
        }
    })

    //hide models and show only images that selected model
    function hideModels() {
        var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
        var colorSelected = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g,'-');           
        jQuery(".box-images img").each(function () {             
                var nameModel = jQuery(this).attr("data-name-model");
                var modelColor = jQuery(this).attr("data-variant-color");
                if (nameModel == modelSelected ) {       
                    jQuery(this).show();
                    jQuery(this).parents("a").show();
                } else {
                    jQuery(this).hide();
                    jQuery(this).parents("a").hide();
                }           
            if(jQuery(this).attr("alt") == "all") {
                jQuery(this).show();
                jQuery(this).parents("a").show();
            }
        })
        if ($(window).width() > 767) {            
            // hideImagesByColor()
            setTimeout(function () {
                if($(window).scrollTop() <= $(".main-thumb .thumb-item:visible").first().offset().top) {
                    $(".secondary-thumb .thumb-item").removeClass("active");
                    $(".secondary-thumb .thumb-item:visible").first().addClass("active");                    
                }
            }, 100);
            $(".secondary-thumb .thumb-item:visible").last().addClass("last-thumb-item");
            $(".main-thumb .thumb-item:visible").last().addClass("last-thumb-item");
        }
    }
    
    function hideImagesByColor() {   
        jQuery('.product-sticky.ui.sticky').sticky("refresh");
        var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
        var colorSelected = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g,'-');           
        jQuery(".box-images img[data-name-model='"+modelSelected+"']").each(function () {          
            
            var modelColor = jQuery(this).attr("data-variant-color");
            if (colorSelected != modelColor) {
                jQuery(this).hide();
                jQuery(this).parents("a").hide();
            } else {
                jQuery(this).show();
                jQuery(this).parents("a").show();
            }
            if(jQuery(this).attr("alt") == "all") {
                jQuery(this).show();
                jQuery(this).parents("a").show();
            }
        })
        $(".secondary-thumb .thumb-item:visible").last().addClass("last-thumb-item");
        $(".main-thumb .thumb-item:visible").last().addClass("last-thumb-item");
    }
    
    function getVariantId(v1, v2) {
        var arrayTitle1, arrayTitle2, arrayIds, array;

        arrayTitle1 = $('.array-title1').text().toLowerCase().split(' ');
        arrayTitle2 = $('.array-title2').text().split(' ');
        arrayIds = $('.array-ids').text().split(',');
        array = [];

        //remove empty index
        arrayTitle1.forEach(function(el, index){
            if (!el) {
                arrayTitle1.splice(index, 1);
            }
        });
        //remove empty index
        arrayTitle2.forEach(function(el, index){
            if (!el) {
                arrayTitle2.splice(index, 1);
            }
        });
        //remove empty index
        arrayIds.forEach(function(el, index){
            if (!el) {
                arrayIds.splice(index, 1);
            }
        });
        
        //build object with variant options
        arrayTitle1.forEach(function(el, index){
            if (arrayTitle1[index] && arrayTitle2[index]) {
                array.push({
                    'color': arrayTitle1[index],
                    'size': arrayTitle2[index],
                    'id': arrayIds[index]
                })
            }
        });
        //get id
        var variantObject = _.find(array, { 'color': v1, 'size': v2 });
        if(variantObject){
            return variantObject.id
        } else{
            return null
        }
    }


    jQuery('.swatch .color :radio').change(function (e) {        
        var selectedColor = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g, "-");
        var selectedSize = $(".swatch-element.size input:checked").val()
        if($(".swatch-element.size input:checked").length){
            $(".product-details--form-wrapper, .fixed-box-addToCart").removeClass("size-not-selected");
            if(getVariantId(selectedColor, selectedSize) != null){
                $(".paymentButtonsWrapper #AddToCart span").text("Add to Bag");
            } else {
                $(".paymentButtonsWrapper #AddToCart span").text("Sold Out");
            }

            $(".fixed-box-addToCart .select-size-text").hide();        
            $(".fixed-box-addToCart .AddToCartText").show();
        }
        if ($(window).width() > 767) {
            e.preventDefault();
            
            var array = [];
            var thumbIndex;
            var windowScroll = $(window).scrollTop();

            $(".secondary-thumb .thumb-item:not([style='display: none;'])").each(function(){
                array.push($(this))
            })
        
            array.forEach(function(el, i){
                if($(el).hasClass("active")) thumbIndex = i;
            })

            hideModels();
            hideImagesByColor();
            hideModelsDescription();
            thumbsActiveOnScroll();

            $("html, body").animate({
                scrollTop: windowScroll
            }, 0);

            jQuery('.product-sticky.ui.sticky').sticky("refresh");
        } else {
            var selectedColor = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g, "-");
            $(".fixed-box-addToCart .sku-color").attr("data-value", selectedColor);
        }
        var swatchHeader = $(this).next().attr("data-title");
        $(this).parents(".swatch").find(".header > p").addClass("color-selected").text(swatchHeader);
    })

    $('.swatch .swatch-element.color').livequery('click', function(){
        var selectedColor = $(this).find("input:checked").val().toLowerCase().replace(/ /g, "-");
        $('.swatch-element.size label, .swatch-element.size').removeClass('soldout')
        $('.swatch-element.size').livequery(function(){
            var selectedSize = $(this).find('input').val()
            if(getVariantId(selectedColor, selectedSize) == null){
                $(this).addClass('soldout')
                $(this).find('label').addClass('soldout')
            }
        })
    })

    var selectedColor = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g, "-");
    $(".fixed-box-addToCart .sku-color").attr("data-value", selectedColor);

    $('.mobile-slider').livequery(function () {
        setTimeout(function(){ 
            $('.swatch .color :radio').on("change",function (e) {
                e.preventDefault();
                var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
                var selectedColor = jQuery("#SingleOptionSelector-0").val().toLowerCase().replace(/ /g, "-");
                // console.log(selectedColor)
                var sliderIndex = $(".mobile-slider:not(.hideThumb) .slick-active").attr("data-slick-index");
                $(".mobile-thumb img").each(function(){
                    if(jQuery(this).attr("alt") != "all") {
                        var model= $(this).attr("alt").replace("/","-").toLowerCase();
                        var nameWithColor = modelSelected + "-"  + selectedColor;
                        if(model == nameWithColor ){
                            jQuery(this).parents(".mobile-slider").slick('slickGoTo', sliderIndex).removeClass("hideThumb")
                        } else { 
                            $(this).parents(".mobile-slider").addClass("hideThumb")
                        }
                    }
                })
            })
        }, 1000);
    })

    //model description
    function hideModelsDescription() {
        var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
        $(".model-description").each(function () {
            modelSelected == $(this).attr("data-name-model") ? $(this).removeClass("hideModel") : $(this).addClass("hideModel");
        })
    }

    $('.secondary-thumb a:visible').first().addClass('active');   
  
    $('.secondary-thumb a').on('click', function() {  
        $('.secondary-thumb a.active').removeClass('active');
        $(this).addClass('active');             
        var windowScroll = $(window).scrollTop()
        var array = []
        var thumbIndex;
        $(".secondary-thumb .thumb-item:not([style='display: none;'])").each(function(){
            array.push($(this))
        })
    
        array.forEach(function(el, i){
            if($(el).hasClass("active")) thumbIndex = i;
        })

        if($(this).index() == 0) {
            $("html, body").animate({
                scrollTop: $("body").offset().top
            }, 0);  
        } else if(windowScroll < $(".main-thumb a:visible").eq(thumbIndex).offset().top) {
            $("html, body").animate({
                scrollTop: $(".main-thumb a:visible").eq(thumbIndex)
            .offset().top - 170 
            }, 0);  
        } else {
            $("html, body").animate({
                scrollTop: $(".main-thumb a:visible").eq(thumbIndex)
            .offset().top - 190 
            }, 0);  
        }        
  
      });
    
   
    if ($(window).width() > 767) {
       hideModels();
        hideImagesByColor();
        $(window).on("scroll",function(){
            if($(window).scrollTop() < 180 ) {
                $('.secondary-thumb .thumb-item').eq(1).removeClass('active');
                $('.secondary-thumb .thumb-item').first().addClass('active');
            }
        })
    }
    hideModelsDescription();

    //mobile and desktop model-select appender
    var modelSelectStructure = $('.model-select').detach();
    var desktopModelSelect = $('.grid__item.box-images .main-thumb');
    var mobileModelSelect = $('.grid__item.box-images');    
    
    if ($(window).width() < 768) {
        modelSelectStructure.insertBefore(mobileModelSelect);

        var titleHeight = $(".model-select").height();

        $('.model-select .model-select--drop--content').css('top', titleHeight);

        $(".model-select--header--title").on("click", function () {
            $(".model-select--drop--content").toggleClass("isOpen");
            $(".model-select").toggleClass("isOpen");
        })

        $(".model-option").on("click", function () {
            $(".model-select--drop--content").removeClass("isOpen");
            $(".model-select").removeClass("isOpen");
        })

    } else {
        $(".model-option").livequery("click", function () {
			$(".model-select--header--title").removeClass("isOpen");
        })
        desktopModelSelect.append(modelSelectStructure);
    }

    $(window).resize(function () {
        if ($(window).width() < 769) {
            var titleHeight = $(".model-select").height();

            $('.model-select .model-select--drop--content').css('top', titleHeight);
            modelSelectStructure.insertBefore(mobileModelSelect);
        } else {
            desktopModelSelect.append(modelSelectStructure);
        }
    });

    jQuery(".custom-field__model-select").on("change", function () {
        hideModels();
        hideModelsDescription();
        if ($(window).width() > 767) {
            hideImagesByColor();
            jQuery('.product-sticky.ui.sticky').sticky("refresh");
        }
        thumbsActiveOnScroll();
        if ($(window).width() < 768) {

            // jQuery(".custom-field__model-select").on("change", function () {
                var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
                var sliderIndex = $(".mobile-slider:not(.hideThumb) .slick-active").attr("data-slick-index");
                var selectedColor = $(".color.swatch-element input:checked").val().toLowerCase().replace(/ /g, "-");
                $(".mobile-thumb .mobile-slider").each(function(){
                    var nameWithColor = modelSelected + "-"  + selectedColor;
                   if($(this).hasClass(nameWithColor)) {
                    jQuery(this).slick('slickGoTo', sliderIndex).removeClass("hideThumb")
                   } else {
                    $(this).addClass("hideThumb")
                   } 
                })
            // })

        }

    })

    $(".mobile-slider").livequery(function(){
        if ($(this).hasClass('slick-slider')) {
            $(".mobile-thumb").addClass('hasSlider');
        }
    })
    
    $(".mobile-thumb").livequery(function(){
        $(".model-option").on("click", function () {
            $(".model-select .model-radioInput").attr("checked", false);
            $(this).prev(".model-radioInput").attr("checked", "checked").trigger('click');
        })
    })
    //increase the area of click of model select
    $(".model-option").on("click", function () {
        $(".model-select .model-radioInput").attr("checked", false);
        $(this).prev(".model-radioInput").attr("checked", "checked").trigger('click');
    })

    //make dropdown of model select
    $(".model-select--drop--content").hover(
        function () {
            $(".model-select--header--title").addClass('isOpen');
        },
        function () {
            $(".model-select--header--title").removeClass('isOpen');
        }
    );

    //toggle models informations between cm and in.
    $(".model-toggle p").on("click", function () {
        $(".model-select").toggleClass("left-in right-cm")
    })
    $(".modal-size-chart .model-toggle").on("click", function () {
        $(".modal-size-chart").toggleClass("left-in right-cm")
    })

    //change swatches titles
    $(".swatch-element.color").parent().find(".header > p").text($(".swatch input:checked+label").attr("data-title"));
    if ($(window).width() >= 768) {
        $(".swatch-element.color label").hover(function () {
            $(this).parents(".swatch").find(".header > p").text($(this).attr("data-title"));
        })
        $(".swatch-element.color label").on("mouseleave", function () {
          	$(this).parents(".swatch").find(".header > p").text($(this).parents(".swatch").find("input:checked").val());
      	})
    }
    jQuery('.swatch .size :radio').change(function (e) {
        e.preventDefault();
        $('[data-testid="ApplePay-button"]').parents("[data-testid='grid-cell']").hide();
        $('[data-testid="GooglePay-button"]').parents("[data-testid='grid-cell']").hide();
        $('.paypalLight').parents("[data-testid='grid-cell']").hide();

        var selectedColor = $(".swatch-element.color input:checked").val().toLowerCase().replace(/ /g, "-");
        var selectedSize = $(".swatch-element.size input:checked").val()
        var swatchHeader = $(this).next().attr("data-title");
        
        $(this).parents(".swatch").find(".header > p").addClass("size-selected").text(swatchHeader);
        
        //change text and color for buy btn
        if($(".swatch-element.size input:checked").length){
            $(".product-details--form-wrapper, .fixed-box-addToCart").removeClass("size-not-selected");

            if(getVariantId(selectedColor, selectedSize) != null){
                $(".paymentButtonsWrapper #AddToCart span").text("Add to Bag");
            } else {
                $(".paymentButtonsWrapper #AddToCart span").text("Sold Out");
            }

            $(".fixed-box-addToCart .select-size-text").hide();        
            $(".fixed-box-addToCart .AddToCartText").show();
        }
        if($(window).width() < 768) {
            var selectedSize = $(".swatch-element.size input:checked").val().replace(/ /g, "-");
            $(".fixed-box-addToCart .skulist span").text(selectedSize);
        }
    })
    if($(window).width() < 768) {
        $(".fixed-box-addToCart.size-not-selected").on("click",function (){
            $("html, body").animate({
                scrollTop: $("#AddToCartForm").offset().top - 120
            }, 300);          
        })
        
        $(window).scroll(function() {
            if($(window).scrollTop() > $('.box-shipping-text').offset().top -  $("#shopify-section-header").height() - 15 ) {
                $(".fixed-box-addToCart").addClass("visible")
            } else {
                $(".fixed-box-addToCart").removeClass("visible")
            }
        });
    }
    //Modals
    jQuery(".box-styling-ideas .fc-item").on("click", function () {
        jQuery(".styling-idea-modal .fc-item").remove()
        jQuery(".styling-idea-modal").append(jQuery(this).clone())
        jQuery(".styling-idea-modal, .modal-backdrop").addClass("open");
        $("body, html").addClass("overflow-hidden");
    })

    jQuery(".product-compression .open-modal").on("click", function () {
        $(".compressions-modal, .modal-backdrop").addClass("open");
        $("body, html").addClass("overflow-hidden");
    })

    jQuery(".box-shipping-text span.open-modal").on("click", function () {
        $(".modal-cart-cta, .modal-backdrop").addClass("open");
        $("body, html").addClass("overflow-hidden");
    })

    jQuery(".swatch .header .open-modal").on("click", function () {
        //$(".modal-size-chart, .modal-backdrop").addClass("open");
        //$("body, html").addClass("overflow-hidden");
    })

    //close modals
    jQuery(".modal-backdrop, .close-modal").on("click", function () {
        jQuery(".styling-idea-modal, .compressions-modal, .modal-cart-cta, .modal-size-chart, .modal-backdrop").removeClass("open");
        $("body").removeClass("overflow-hidden");
        $("html").removeClass("overflow-hidden");
    })

    jQuery('.product-features .custom-field--value').on('afterChange', function (event, slick, currentSlide) {        
        currentSlide === slidersQuantity - 1 ? $('.slick-next').addClass('disabled') : $('.slick-next').removeClass('disabled');
        currentSlide === 0 ? $('.slick-prev').addClass('disabled') : $('.slick-prev').removeClass('disabled');
    })



    var modelsArray = []
    $(".mobile-thumb img").each(function(){
        modelsArray.push($(this).attr("alt").replace("/","-").toLowerCase());
    })
    
    modelsArray = modelsArray.filter((el, i, a) => i === a.indexOf(el))
    
    
    modelsArray.map(function(i){
        $(".mobile-thumb").append(`<div class="mobile-slider slider-${i} ${i}">`)
    })

    function mobileHideModels() {
        // $(".mobile-slider").livequery(function(){
            $(".mobile-thumb img").each(function(){
                var model= $(this).attr("alt").replace("/","-").toLowerCase();
                var modelSelected = jQuery(".custom-field__model-select").find(".model-radioInput:checked").val().toLowerCase();
                var selectedColor = $(".color.swatch-element input:checked").val().toLowerCase().replace(/ /g, "-");
                var nameWithColor = modelSelected + "-"  + selectedColor;
        
                $(`.mobile-thumb .slider-${model}`).append($(this).parent());    
                model == nameWithColor ? $(this).parents(".mobile-slider").removeClass("hideThumb") : $(this).parents(".mobile-slider").addClass("hideThumb")
            })     
            $(".mobile-slider").append(jQuery(".mobile-thumb img[alt='all']").parent());       
            // $(".mobile-slider").each(function(){
            //     $(this).append(jQuery(".mobile-thumb img[alt='all']").parent())
            // })
        // })
        // $(".mobile-slider").append(jQuery(".mobile-thumb img[alt='all']").parent())
    }
    if ($(window).width() < 768) {
        mobileHideModels()
    }
    
    function thumbsActiveOnScroll () {
        if ($(window).width() > 768) {
            $(".main-thumb .thumb-item").each(function(){
                var $this = $(this)
                var waypoint = new Waypoint({
                    element: $this,
                    handler: function(direction) {
                        if($(window).scrollTop() < 200) {
                            $(".secondary-thumb .thumb-item").removeClass("active");
                            $(".secondary-thumb .thumb-item:visible").first().addClass("active");
                        } else {
                            var i = this.element.index() - 1;
                            $(".secondary-thumb .thumb-item").removeClass("active");
                            $(".secondary-thumb .thumb-item").eq(i).addClass("active");
                        }
                    },
                    offset: 180
                })
            })    
        }
    }

    thumbsActiveOnScroll()

    function imgExpanded($this) {
        $(".modal-slider-thumb .box-slider figure").remove();
        if ($(window).width() > 767) {
            $(".modal-slider-thumb .box-slider").append(jQuery(".main-thumb .product-single__photos a.thumb-item:visible figure").clone())    
          
            // change img quality
            $(".modal-slider-thumb .box-slider img").each(function(){
                var imgSrc = $(this).attr("src").replace("300x","1920x");
                $(this).attr("src", imgSrc);
                $(this).removeAttr("data-srcset").removeAttr("srcset");
            })
            
            var imgId = $this.find("img").attr("data-image-id");
            
            // tirar do if caso queiram modal com slider na thumb no mobile;
            setTimeout(function(){ 
              jQuery(".modal-slider-thumb .box-slider").slick({
                speed: 0,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchMove: false,
                dots: false,
                adaptiveHeight: true,
                infinite: true,
              })
              
              var thumbIndex = $(".modal-slider-thumb img[data-image-id='"+imgId+"']").parents(".slick-slide").attr("data-slick-index");
              jQuery(".modal-slider-thumb .box-slider").slick('slickGoTo', thumbIndex);                          
              $(".modal-slider-thumb").addClass("open");
              jQuery(".modal-slider-thumb .box-slider").slick('refresh');

            }, 1000);
            setTimeout(function(){ 
                jQuery('.box-slider').slick('setPosition');
                jQuery(".modal-slider-thumb .box-slider").slick('slickGoTo', thumbIndex);
                jQuery(".modal-slider-thumb .box-slider").slick('refresh');
            }, 1100);

        } else {
            $(".modal-slider-thumb .box-slider a").remove();
            
            // descomentar caso queiram modal com slider na thumb no mobile;                      
            // $(".modal-slider-thumb .box-slider").append(jQuery(".main-thumb .product-single__photos a.thumb-item img[data-name-model='"+modelSelected+"'][data-variant-color='"+selectedColor+"']").parents("figure").clone())
            
            // comentar caso queiram modal com slider na thumb no mobile;                      
            $(".modal-slider-thumb .box-slider").append($(".mobile-slider:not(.hideThumb) a.slick-current").clone().removeAttr("class"));
            var imgWidth = $(".modal-slider-thumb img").width() 
            $(".modal-slider-thumb").animate({
                scrollLeft: imgWidth / 3.5
            }, 0);
            $(".modal-slider-thumb").addClass("open");
            
        }
        
        $(".modal-slider-thumb .box-slider a").attr("href", "#")       		        
       
        jQuery(".close-modal-slider-thumb").on("click", function (){
            $(".modal-slider-thumb").removeClass("open")                       
            jQuery(".modal-slider-thumb .box-slider").slick("unslick")
        })        
    }

    // esses 2 listeners de click estao no custom js dentro da funcao de zoom

    // jQuery(".main-thumb a .js__image_already_loaded").parents(".main-thumb").find("a").on("click", function () {
    //     imgExpanded($(this))        
    // })
    // jQuery(".main-thumb .product-single__photo-wrapper .js__image_already_loaded").parents(".product-single__photo-wrapper").on("click", function () {
    //     imgExpanded($(this))        
    // })

    // esses 2 listeners de click estao no custom js dentro da funcao de zoom

    jQuery(".mobile-thumb .thumb-zoom, .mobile-thumb .mobile-slider a").on("click", function () {
        imgExpanded($(this))        
    })
    
    //close modals with esc key word
    $(window).keydown(function(){
        if (event.keyCode == 27) {
            jQuery(".close-modal-slider-thumb, .close-modal").trigger("click");
        }	
    })

    if($(window).width()< 768){
        $(window).on('resize', function () {
            if($(window).width() >= 768){
                location.reload();
            }
        });
    } else {
        $(window).on('resize', function () {
            if($(window).width() <= 767){
                location.reload();
            }
        });
    }

    //product features slider
    var slidersQuantity = jQuery(".product-features .custom-field--value .fc-item").length
    jQuery(".product-features .custom-field--value").slick({
        speed: 200,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        dots: true,
        adaptiveHeight: true
    })
    
    //box compressions slider 
    if ($(window).width() < 768) {
        jQuery(".compressions-modal .box-compressions").slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchMove: true,
            dots: true,
            adaptiveHeight: true
        })
    }

    jQuery(".mobile-slider").slick({
        arrows: false,
        speed: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: true,
        dots: true,
        adaptiveHeight: true
    })

})


var productPageFnc = {
    init: function(){;
        productPageFnc.ZoomSlider();
        productPageFnc.removeZoomLapse();
    },

    slideRefresh: function(){
        console.log('a');
        $('.template-product .thumb-item').livequery('click',function(){
            jQuery(".modal-slider-thumb .box-slider").slick('refresh');
            setTimeout(function(){ 
                jQuery(".modal-slider-thumb .box-slider").slick('refresh');
            },600);
        })
    },

    elementShowed: function(){
        $(document.body).on('appear', '.modal-slider-thumb.open', function(e, $affected) {        
            // this element is now inside browser viewport
            alert('a');
        });        
    },

    removeZoomLapse: function(){
        $('product-sticky-wrapper').livequery('click', function(){
            jQuery("body").removeClass("js-fullthumb-opened");
        })
    },

    reSlickMobile: function(){
        $('.paymentButtonsWrapper, .drawer__close').livequery('click', function(){
            setTimeout(function(){
                jQuery(".modal-slider-thumb .box-slider").slick('refresh');
            }, 900)
        })
    },

    ZoomSlider: function(){
        $('.template-product .main-thumb .thumb-item').livequery('click',function(){
            jQuery("body").removeClass("js-fullthumb-opened");
            $this = $(this);
            $(".modal-slider-thumb .box-slider figure").remove();
            if ($(window).width() > 767) {

            
                
                // tirar do if caso queiram modal com slider na thumb no mobile;
                setTimeout(function(){ 
                $(".modal-slider-thumb .box-slider").append(jQuery(".main-thumb .product-single__photos a.thumb-item:visible figure").clone())    
                // change img quality
                $(".modal-slider-thumb .box-slider img").livequery(function(){
                    var imgSrc = $(this).attr("src").replace("300x","1920x");
                    $(this).attr("src", imgSrc);
                    $(this).removeAttr("data-srcset").removeAttr("srcset");
                })
                
                var imgId = $this.find("img").attr("data-image-id");
                jQuery(".modal-slider-thumb .box-slider").slick({
                    speed: 0,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    touchMove: false,
                    dots: false,
                    adaptiveHeight: true,
                    infinite: true,
                })
                
                    $(".modal-slider-thumb").addClass("open");
                    // $('.box-slider').hide();
                    var thumbIndex = $(".modal-slider-thumb img[data-image-id='"+imgId+"']").parents(".slick-slide").attr("data-slick-index");
                    jQuery(".modal-slider-thumb .box-slider").slick('slickGoTo', thumbIndex);
                    // $('.box-slider').show();
                    jQuery("body").addClass("js-fullthumb-opened");
                
                
                // jQuery(".modal-slider-thumb .box-slider").slick('resize');

                }, 400);
                jQuery(".close-modal-slider-thumb").on("click", function (){
                    jQuery("body").removeClass("js-fullthumb-opened");
                    $(".modal-slider-thumb").removeClass("open")                       
                    jQuery(".modal-slider-thumb .box-slider").slick("unslick")
                })  
        
            } else {
                $(".modal-slider-thumb .box-slider a").remove();
                
                // descomentar caso queiram modal com slider na thumb no mobile;                      
                // $(".modal-slider-thumb .box-slider").append(jQuery(".main-thumb .product-single__photos a.thumb-item img[data-name-model='"+modelSelected+"'][data-variant-color='"+selectedColor+"']").parents("figure").clone())
                
                // comentar caso queiram modal com slider na thumb no mobile;                      
                $(".modal-slider-thumb .box-slider").append($(".mobile-slider:not(.hideThumb) a.slick-current").clone().removeAttr("class"));
                var imgWidth = $(".modal-slider-thumb img").width() 
                $(".modal-slider-thumb").animate({
                    scrollLeft: imgWidth / 3.5
                }, 0);

                setTimeout(function(){
                    $(".modal-slider-thumb").addClass("open");
                    jQuery(".modal-slider-thumb .box-slider").slick('refresh');
                }, 400)
                
                // jQuery(".modal-slider-thumb .box-slider").slick('refresh');
            }
            
                $(".modal-slider-thumb .box-slider a").attr("href", "#")       		        
            
                jQuery(".close-modal-slider-thumb").on("click", function (){
                    jQuery("body").removeClass("js-fullthumb-opened");
                    $(".modal-slider-thumb").removeClass("open")                       
                    jQuery(".modal-slider-thumb .box-slider").slick("unslick")
                })
        });
    }
}

$(window).load(function () {
    productPageFnc.init();
    jQuery(".product-sticky").css("visibility", "visible");
    if($(".model-select--drop--content .model-option").length == 1) $(".main-thumb").addClass("oneModelSelect");
    if($(".model-select--drop--content .model-option").length == 1) $(".model-select--header--title").css("pointer-events","none");
});
